import {
	MaterialReactTable,
	useMaterialReactTable,
} from "material-react-table";

import "./CustomTable.scss";
import React from 'react';


import { Button, Icon } from "abs-ui-components";
import { useState} from "react";
import { Checkbox } from "@mui/material";

const CustomTable = ({ renderTableData, columnsData, customProps,isUkEtsChildReport }) => {
	const [selectAll, setSelectAll] = useState(false);
	const [customTableSort, setCustomTableSort] = useState([]);
	const handleSelectAll = (event) => {
		setSelectAll(event.target.checked);
	};
	
	const custTable = useMaterialReactTable({
		columns: columnsData,
		data: renderTableData || [],
		enableStickyHeader: true,
		enablePagination: false,
		enableSorting: customProps?.enableSort,
		enableColumnVirtualization: customProps.enableColumnVirtualization ?? true,
		enableRowVirtualization: customProps.enableRowVirtualization ?? true,
		enableColumnPinning: customProps?.enableColumnPinning ?? false,
		enableColumnActions: false,
		enableEditing: false,
		enableRowSelection: false,
		enableTopToolbar: customProps?.enableToptoolbar,
		enableBottomToolbar: false,
		columnResizeMode: customProps?.columnResize,
		enableStickyFooter: customProps?.enableStickyFooter,
		state: {
			isLoading: customProps?.isLoading,
			sorting: customTableSort,
			onSortingChange: setCustomTableSort,
		},
		initialState: {
			columnOrder: customProps?.columnOrder || [],
			columnPinning: customProps?.columnPinning || {
				left: [],
				right: [],
			},
		},

		//for future scope
		renderToolbarInternalActions: ({ table }) => <></>,

		renderTopToolbarCustomActions: ({ table }) => (
			<>
				<div className="container-fluid p-1">
					<div className="row p-0 m-0 d-flex justify-content-between align-items-center">
						<div className="text-color">
							<div>{customProps?.header}</div>
							<div className="text-size">
								{customProps?.subHeader}
							</div>
						</div>
						<div>
							{customProps?.showExportButton && (
								<Button
									disabled={customProps?.exportLoading}
									startIcon={<Icon icon="ios_share" />}
									onClick={customProps?.handleExportTable}
									variant="secondary"
									className="ml-2"
								>
									{customProps?.exportLoading
										? "Please wait..."
										: customProps.exportText ||
										"Export Table"}
								</Button>
							)}
						</div>
					</div>
				</div>
			</>
		),

		muiTableHeadCellProps: ({ column }) => ({
    id: `${column.columnDef.accessorKey}`,
    sx: {
        color: "rgb(255 255 255)",
        height: customProps?.height,
        opacity: "1",
        "& .MuiTableCell-root": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        },
        "& .Mui-TableHeadCell-Content": {
            justifyContent: "center",
            width: "100%",
        },
        "& .MuiButtonBase-root": {
            color: "white !important",
            "& .MuiTableSortLabel-icon": {
                color: "white !important",
            },
        },
    },
}),

		muiFilterTextFieldProps: {
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
			},
		},

		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},

		muiSelectAllCheckboxProps: {
			title: selectAll ? "Toggle deselect all" : "Toggle select all",
			onClick: (e) => handleSelectAll(e),
			sx: {
				color: "white",
			},
		},

		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",

				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},

				"& .MuiDivider-root": {
					backgroundColor: "white",
				},
			},
		},

		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},
		muiTableBodyCellProps: ({ cell }) => {

			const value = cell.getValue();
			const isBoolean = value === true || value === false;

			const isDecimal = !isNaN(parseFloat(value)) && isFinite(value) && cell.column.columnDef.accessorKey!== "reportingYear";
			const decimalPlaces = isUkEtsChildReport ? 5 : 3;

			const roundedValue = isDecimal? parseFloat(value).toFixed(decimalPlaces): value;

			return {
				sx: {
					overflow: customProps.tableName === "EUETS" ? "visible" : "hidden",
					opacity: "1",
				},
				title: isDecimal ? value.toString() : undefined, // Set original value as tooltip
				children: !customProps.showSwitch?  (isDecimal ? roundedValue : (isBoolean ? 
				<Checkbox
					className="p-0"
					size="small"
					disabled={!value}
					checked={value}
				/> : value)):null
			};
		},


		muiTableContainerProps: {
			sx: {
				maxHeight: renderTableData?.length
					? customProps?.tableName === "emissions-report"
						? customProps?.maxHeight
						: "calc(100vh - 343px)"
					: "auto",
				overflowY: renderTableData?.length ? "auto" : "hidden",
			},
		},
		muiTableFooterCellProps: {
			sx: {
				opacity: "1",
			},
		},
	});
	return (
		<>
			<div className="bdn-custom-table-container">
				<MaterialReactTable table={custTable} />
			</div>
		</>
	);
};

export default CustomTable;